export const PaymentPlanCard = {
  flow: 'y',
  gap: 'Z',
  padding: 'B',
  round: 'Z',
  background: 'inkMid',
  border: '1px solid inkBorder',

  TotalBalance: {
    flow: 'y',
    gap: 'X',
    Label: { text: '{{ totalBalance | polyglot }}', fontSize: 'Y', color: 'inkMuted', fontWeight: '600', textTransform: 'uppercase', letterSpacing: 'X' },
    Value: { text: (el, s) => s.totalBalance || '', fontSize: 'C', fontWeight: '800', color: 'inkText' }
  },

  DetailsRow: {
    flow: 'x',
    gap: 'A',
    flexWrap: 'wrap',
    MonthlyPayment: {
      flow: 'y',
      gap: 'X',
      Label: { text: '{{ monthlyPayment | polyglot }}', fontSize: 'Y', color: 'inkMuted' },
      Value: { text: (el, s) => s.monthlyPayment || '', fontSize: 'Z', fontWeight: '700', color: 'inkText' }
    },
    PaymentsRemaining: {
      flow: 'y',
      gap: 'X',
      Label: { text: '{{ paymentsRemaining | polyglot }}', fontSize: 'Y', color: 'inkMuted' },
      Value: { text: (el, s) => s.paymentsRemaining != null ? String(s.paymentsRemaining) : '', fontSize: 'Z', fontWeight: '700', color: 'inkText' }
    },
    NextPaymentDate: {
      flow: 'y',
      gap: 'X',
      Label: { text: '{{ nextPayment | polyglot }}', fontSize: 'Y', color: 'inkMuted' },
      Value: { text: (el, s) => s.nextPaymentDate || '', fontSize: 'Z', fontWeight: '600', color: 'inkText' }
    }
  },

  AutoPayStatus: {
    flow: 'x',
    align: 'center flex-start',
    gap: 'Y',
    Dot: {
      width: 'Y',
      height: 'Y',
      round: '100',
      background: (el, s) => s.autoPay ? 'green' : 'amber'
    },
    Label: {
      text: (el, s) => s.autoPay ? 'AutoPay On' : 'AutoPay Off',
      fontSize: 'Y',
      fontWeight: '600',
      color: (el, s) => s.autoPay ? 'green' : 'amber'
    }
  },

  ProgressWrap: {
    flow: 'y',
    gap: 'Y',
    ProgressLabel: { text: '{{ paymentProgress | polyglot }}', fontSize: 'Y', color: 'inkMuted' },
    ProgressBar: {
      width: '100%',
      height: 'Y',
      round: 'Y',
      background: 'inkBorder',
      overflow: 'hidden',
      Fill: {
        height: '100%',
        round: 'Y',
        background: 'teal',
        width: (el, s) => {
          const pct = s.progressPercent || 0
          return `${pct}%`
        },
        transition: 'width 0.3s'
      }
    },
    ProgressPercent: {
      text: (el, s) => s.progressPercent != null ? `${s.progressPercent}% complete` : '',
      fontSize: 'Y',
      color: 'inkMuted'
    }
  }
}
